export const PLATFORM_META: Record<string, { name: string; color: string; softColor: string }> = {
  ebay: { name: 'eBay', color: '#0064d2', softColor: '#eaf3ff' },
  mercari: { name: 'Mercari', color: '#ff5a5f', softColor: '#fff0f0' },
  煤炉: { name: 'Mercari', color: '#ff5a5f', softColor: '#fff0f0' },
  snkrdunk: { name: 'SNKRDUNK', color: '#111827', softColor: '#eef1f5' },
  kale: { name: 'Kale', color: '#16a34a', softColor: '#edf9f0' },
  katao: { name: 'Katao', color: '#7c3aed', softColor: '#f3efff' },
  pwcc: { name: 'PWCC', color: '#b7791f', softColor: '#fff7e6' },
};

export function platformMeta(platform: string) {
  return PLATFORM_META[platform.toLowerCase()] || {
    name: platform || 'Unknown market',
    color: '#5f6b7a',
    softColor: '#f3f6fa',
  };
}

export function formatUsd(value?: number | null) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 'USD unavailable';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: value >= 100 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatSaleDate(timestamp?: number | null) {
  if (typeof timestamp !== 'number' || !Number.isFinite(timestamp)) return 'Date unavailable';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(timestamp));
}

export function median(values: number[]) {
  if (values.length === 0) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0
    ? (sorted[middle - 1] + sorted[middle]) / 2
    : sorted[middle];
}
